import { Pipe, PipeTransform } from '@angular/core';

export const OneMillion = 1_000_000;
export const OneTrillion = 1_000_000_000_000;

@Pipe({
	standalone: true,
	name: 'priceNumber'
})
export class PriceNumberPipe implements PipeTransform {
	transform(value: number): string {
		if ([undefined, null, NaN].includes(value)) return '-';

		let result = '';
		let absValue = Math.abs(Math.floor(value));

		if (value < OneTrillion) {
			result = absValue.toLocaleString();
		} else {
			absValue = Math.trunc(absValue / OneMillion);
			result = `${absValue.toLocaleString()} M`;
		}

		return `${value < 0 ? '-' : ''}${result}`;
	}
}
